import { AnimatePresence, motion } from 'framer-motion'

interface TipCardProps {
  visible: boolean
  onDismiss: () => void
  emoji: string
  title: string
  steps?: string[]
  body?: string
  cta?: string
  onCta?: () => void
}

export default function TipCard({
  visible,
  onDismiss,
  emoji,
  title,
  steps,
  body,
  cta,
  onCta,
}: TipCardProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ type: 'spring', stiffness: 300, damping: 28 }}
          className="mx-4 mb-3 rounded-2xl bg-white border border-[#E8F2EA] overflow-hidden shadow-sm"
        >
          {/* Green accent bar */}
          <div className="h-1 bg-[#6B9E78]" />

          <div className="px-4 py-3">
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2">
                <span className="text-xl">{emoji}</span>
                <p className="text-sm font-semibold text-[#2C2A26]">{title}</p>
              </div>
              <button
                onClick={onDismiss}
                className="text-[#9A9491] text-base leading-none shrink-0 mt-0.5"
              >
                ×
              </button>
            </div>

            {steps && steps.length > 0 && (
              <ol className="mt-2 flex flex-col gap-1 pl-1">
                {steps.map((step, i) => (
                  <li key={i} className="flex items-start gap-2 text-xs text-[#7A7468]">
                    <span className="font-semibold text-[#6B9E78] shrink-0">{i + 1}.</span>
                    <span>{step}</span>
                  </li>
                ))}
              </ol>
            )}

            {body && (
              <p className="mt-2 text-xs text-[#7A7468] leading-relaxed">{body}</p>
            )}

            {cta && onCta && (
              <button
                onClick={onCta}
                className="mt-3 text-xs font-semibold text-[#6B9E78]"
              >
                {cta} →
              </button>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
